import { GraphemeSvgGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.svg";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { useGetGraphemeGlyph } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.glyph/client";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMemo } from "react";
import { View } from "@-/com.npmjs.react-native";

/**
 * The glyph above a mnemonics heading. It is monochrome unless a reading passes its tone `color`:
 * only the pronunciation tabs colour the glyph, never the meaning (glyph) tab.
 */
export function MorphemeMnemonicsHeroGlyph({
  className = "w-full items-center gap-1",
  color,
}: {
  className?: string;
  color?: string | null;
}) {
  const [front, graphemeStrokes] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.grapheme,
    (c) => c.readonlySlice.data.graphemeStrokes,
  );
  const getGraphemeGlyph = useGetGraphemeGlyph();
  const characterGlyph = getGraphemeGlyph(front, { uncolored: true });
  const strokeList = useMemo(
    () =>
      graphemeStrokes === null
        ? null
        : graphemeStrokes.map(({ median, path }) => ({ median, path })),
    [graphemeStrokes],
  );

  return (
    <View className={className} testID="meaning-header-glyph">
      <View className="size-20 items-center justify-center rounded-xs">
        <GraphemeSvgGlyph
          color={color ?? undefined}
          glyph={characterGlyph}
          showBackground={false}
          size={80}
          strokeList={strokeList}
        />
      </View>
    </View>
  );
}
